import { ErrorBoundary } from 'react-error-boundary';
import ErrorFacllbackModal from '@/components/ErrorFallback/ErrorFacllbackModal';
import { memo, Suspense } from 'react';
import ChunkLoading from '@/components/ChunkLoading';
// import ErrorFallback from '../../ErrorFallback';

const reload = () => window.location.reload();

const ChunkLazyLoadWrapper: React.FC<{
  Component: React.LazyExoticComponent<React.ComponentType<any>>;
  [key: string]: any;
}> = ({ chunkName, Component, ...props }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFacllbackModal} onReset={reload}>
      <Suspense fallback={<ChunkLoading chunkName={chunkName} />}>
        <Component {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default memo(ChunkLazyLoadWrapper);
